export default [

  /*** 广告管理 开始 ***/
  {
    path: '/ad/list',
    component: () => import('../pages/application/ad/list.vue'),
    meta: {title: '广告列表'}
  },
  {
    path: '/ad/position',
    component: () => import('../pages/application/ad/position.vue'),
    meta: {title: '广告位置'}
  },
  /*** 广告管理 结束 ***/

  /*** 客户端管理 开始 ***/
  {
    path: '/client',
    component: () => import('../pages/application/client/index.vue'),
    meta: {title: '客户端管理'}
  },
  /*** 客户端管理 结束 ***/

  /*** 菜单项管理 开始 ***/
  {
    path: '/menu/list',
    component: () => import('../pages/application/menu/list.vue'),
    meta: {title: '菜单列表'}
  },
  {
    path: '/menu/position',
    component: () => import('../pages/application/menu/position.vue'),
    meta: {title: '菜单位置'}
  },
  /*** 菜单项管理 结束 ***/

  /*** 系统配置 开始 ***/
  {
    path: '/configure',
    component: () => import('../pages/application/configure/index.vue'),
    meta: {title: '系统配置'}
  },
  /*** 系统配置 结束 ***/

  /*** 协议管理 开始 ***/
  {
    path: '/agreement',
    component: () => import('../pages/application/agreement/index.vue'),
    meta: {title: '协议管理'}
  },
  {
    path: '/agreement/edit/:agreementId',
    component: () => import('../pages/application/agreement/edit.vue'),
    meta: {title: '协议编辑'}
  },
  {
    path: '/agreement/create',
    component: () => import('../pages/application/agreement/create.vue'),
    meta: {title: '协议创建'}
  },
  /*** 协议管理 结束 ***/



]


